<template>
<div class="container-fluid">
    <div class="card animated fadeIn">
        <!-- <pre>{{this.device.product.fw_versions}}</pre> -->
        <!-- <b-form @submit.prevent="updateDevice()"> -->
        <b-row>
            <b-col sm=8>
                <b-card>
                    <div slot="header">
                        <strong>Upgrade Firmware:</strong>
                        <span v-if="device.presence != 1">Upgrade disabled. Device is offline.</span>
                    </div>
                    <div v-if="device.presence == 1">
                        <b-form-group label="Current Firmware:0000" :label-cols-sm="3">
                            <b-form-input type="text" v-model="device.fw_version" readonly></b-form-input>
                        </b-form-group>
                        <b-form-group label="Select Firmware:" label-for="firmware" :label-cols-sm="4" class="w-50">
                            <multiselect v-model="value" :options="device.product.fw_versions" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="false" placeholder="search ..." :show-labels="false" label="name" track-by="id" :preselect-first="false" :hideSelected="false" :allow-empty="true" :disabled=!readonly>
                                <template slot="selection" slot-scope="{ values, search }">
                                </template>
                            </multiselect>
                        </b-form-group>

                        <b-form-group label="Reset:" label-for="factoryReset" :label-cols-lg="4" class="w-50" v-if="value">
                            <b-form-checkbox v-model="factoryReset" name="factoryReset" size="sm" switch :disabled=!readonly> Reset settings to factory defaults?</b-form-checkbox>
                        </b-form-group>

                        <div v-if="value.changeLog">
                            <label class="col-md-3 col-form-label" for="text-input">Change Log:</label>
                            <pre>{{value.changeLog}}</pre>
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col sm=4>
                <b-card>
                    <div slot="header">
                        <strong>Details</strong>
                    </div>
                    Info goes here
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm=8>
                <div class="text-center" v-if="device.presence == 1">
                    <button v-if="readonly" :disabled="device.presence != 1 || verrors.any() || value.id == null || value.name == device.fw_version" class="btn btn-primary" @click="sendCmd(value.id, factoryReset)">Upgrade Firmware</button>
                </div>
            </b-col>
        </b-row>
        <!-- </b-form> -->
    </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { vm } from '@/app.js'

export default {
    components: {

        Multiselect,
    },

    props: {
        device: {
            type: Object,
            default: function () {
                return {}
            }
        },
    },

    data() {
        return {
            profile: {},
            submitted: false,
            product_opts: [],
            account_opts: [],
            factoryReset: false,
            resp: {},

            value: {},
            selectedIds: [],

            loading: 'true',
        };

    },

    created() {
        let empty_fw = { id: null, name: '' };
        this.device.product.fw_versions.unshift(empty_fw);

    },

    computed: {
        optionsArray() {
            return Object.keys(this.options).map(i => this.options[i]);
        },
        readonly() {
            return this.$can('device', 'edit')
        },
    },

    methods: {
        // toArray(obj_obj) {
        //   return Object.keys(obj_obj).map(i => obj_obj[i]);
        // },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.verrors.has(ref)
            }
            return null
        },

        sendCmd(fwID, reset) {
            this.resp.fw_versionID = fwID;
            this.resp.fw_reset = reset;
            // let uri = `/api/devices/${this.device.id}/upgrade_firmware?fwVersionID=${fwID}&reset=${reset}`;
            let uri = `/api/devices/${this.device.id}/upgrade_firmware`;
            axios.post(uri, this.resp).then((response) => {
                if (response.data.success === true) {
                    this.makeToast('info', "Firmware upgrade request received.");
                    window.location.reload();
                } else {
                    this.makeToast('danger', 'Firmware upgrade request failed.');
                }
            });

            console.log(fwID, reset);
        },

        makeToast(variant = null, message = null) {
            this.$bvToast.toast(message, {
                // title: `Config Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                solid: true
            });
            // toast.show();
        },
    }

}
</script>
